export default __webpack_public_path__ + "static/media/send.469e9f89.svg";